import React, { useEffect, useState } from "react";
import { StatusChip } from "../../../components/Chip/Chip";
import { TickIcon } from "../../../front-end-global-components/assets/assets";
import Button from "../../../front-end-global-components/components/Button/Button";
import CheckBox from "../../../front-end-global-components/components/CheckBox/CheckBox";
import ConditionalRender from "../../../front-end-global-components/components/ConditionalRender/ConditionalRender";
import InputBox from "../../../front-end-global-components/components/InputBox/InputBox";
import RoundedProfilePicture from "../../../front-end-global-components/components/RoundedProfilePicture/RoundedProfilePicture";
import Select from "../../../front-end-global-components/components/Select/Select";
import {
  AbdmConsentHealthInfoTypes,
  consentStatus,
  lockerSetup
} from "../../../utils/constants";
import { isValidArray, validation } from "../../../utils/validators";
import { DocumentCard } from "../../../components/Cards/Cards";

export const getheaderTitle = (abdmRequestType) => {
  switch (abdmRequestType) {
    case "subscription":
      return "Subscription request";
    case "consent":
      return "Consent request";
    case "lockerSetup":
      return "Health locker request";
    case "authorization":
      return "Authorization request";
    default:
      return "Consent request";
  }
};

export const purposeOfRequest = (request) => {
  return request?.subscription
    ? request.subscription.purpose?.text
    : request.purpose?.text;
};

export const remainingDateConversion = (date) => {
  const timeStamp = +new Date(date) - +new Date();
  const remainingMonth = Math.round(timeStamp / (1000 * 60 * 60 * 24 * 30));
  const remainingDays = Math.round(timeStamp / (1000 * 60 * 60 * 24));

  return remainingMonth < 1
    ? `(${remainingDays} Day${remainingDays === 1 ? "" : "s"})`
    : `(${remainingMonth} Month${remainingMonth === 1 ? "" : "s"})`;
};

export const ConsentFooter = (props) => {
  return (
    <>
      {props.status === consentStatus.approved &&
        (props.editOnClick ? (
          !props.editOption && (
            <div>
              <section
                onClick={() => {
                  if (props.loading) return;
                  props.editOnClick();
                }}
                className="padding-top-large padding-bottom-large  padding-left-large padding-right-large  font-size-small font-family-gilroy-regular  text-align-center line-height-140-percentage"
              >
                Need to edit this service to access the above mentioned <br />
                {""}
                records?
                <span className="font-color-primary padding-left-small">
                  Edit access
                </span>
              </section>
            </div>
          )
        ) : (
          <div>
            {typeof props.revokeAccessOnClick === "function" && (
              <section
                onClick={() => {
                  if (props.loading) return;
                  props.revokeAccessOnClick();
                }}
                className="padding-top-large padding-bottom-large  padding-left-large padding-right-large  font-size-small font-family-gilroy-regular  text-align-center line-height-140-percentage"
              >
                Don’t want this service to access the above mentioned <br />
                {""}
                records?
                <span className="font-color-red padding-left-small">
                  Revoke access
                </span>
              </section>
            )}
          </div>
        ))}

      {props.status !== consentStatus.expired &&
      (props.status === consentStatus.pending || props.editOption) ? (
        <section className="padding-left-larger padding-right-larger padding-bottom-larger">
          {props.type !== "authorization" && (
            <div className="padding-bottom-larger text-align-center font-size-small font-family-gilroy-regular font-color-secondary">
              By approving, you agree with Ninto’s terms of service & privacy
              policies. You can opt out of this any time.
            </div>
          )}
          <div className="display-flex">
            <Button
              type="submit"
              boxShadow={false}
              text={props.editOption ? "Confirm" : "Approve"}
              disabled={props.approveButtonDisabled}
              onClick={(event) => {
                props.approveOnClick(event);
              }}
              loading={props.loading}
              className="font-family-gilroy-medium border-1px-e5e5e5 margin-right-large"
              data-cy="accept-button"
            />

            {typeof props.denyOnClick === "function" && !props.editOption && (
              <Button
                loading={props.loading}
                boxShadow={false}
                text="Deny"
                variant="secondary"
                onClick={(event) => {
                  if (!props.approveButtonDisabled) {
                    props.denyOnClick(event);
                  }
                }}
                className="font-color-red border-1px-e5e5e5 margin-left-large"
                data-cy={`deny-button`}
              />
            )}

            {typeof props.ignoreOnClick === "function" && !props.editOption && (
              <Button
                loading={props.loading}
                disabled={props.approveButtonDisabled}
                boxShadow={false}
                text="Ignore"
                variant="secondary"
                onClick={(event) => {
                  props.ignoreOnClick(event);
                }}
                className={" border-1px-e5e5e5 margin-left-small"}
                data-cy={`Ignore-button`}
              />
            )}

            {props.editOption && (
              <Button
                loading={props.loading}
                boxShadow={false}
                text="Cancel"
                variant={"secondary"}
                onClick={(event) => {
                  props.editRequest_cancelOnClick(event);
                }}
                className={" border-1px-e5e5e5 margin-left-small"}
                data-cy={`cancel-button`}
              />
            )}
          </div>
        </section>
      ) : null}
    </>
  );
};

export const ConsentHeader = (props) => {
  return (
    <div className="display-flex padding-bottom-large">
      <div className="display-flex flex-grow-1 flex-align-items-center">
        <RoundedProfilePicture size={"medium"} />
        <div className="flex-grow-1 flex-direction-column display-flex padding-left-medium">
          <span className="font-size-medium font-family-gilroy-regular font-color-secondary">
            {props.consentRequesterName}
          </span>
          <span
            className="font-size-small font-family-gilroy-regular text-transform-capitalize padding-top-small"
            //   data-cy={clinicName}
          >
            {props.consentRequesterSubName}
          </span>
        </div>
        <StatusChip status={props.status} />
      </div>
    </div>
  );
};

export const DisableAutoApproveSection = (props) => {
  return (
    <section className="font-color-secondary font-family-gilroy-medium font-color-secondary text-align-center padding-larger">
      <section className="">
        <div className="">Disable auto-approval</div>
        <div className="font-size-small padding-top-large">
          Disabling this auto-approval policy would stop consent requests from
          <span className="font-family-gilroy-bold">
            {" "}
            {props.hospitalName}{" "}
          </span>
          to be automatically approved.
        </div>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            props.disableOnclick();
          }}
        >
          <section className="display-flex padding-top-larger">
            <Button
              loading={props.loading}
              boxShadow={false}
              type="submit"
              variant="danger"
              text="Disable"
              className="border-1px-e5e5e5 margin-right-default"
            />
            <Button
              boxShadow={false}
              text="Cancel"
              variant="secondary"
              onClick={() => {
                props.cancelOnClick();
              }}
              className="font-color-secondary border-1px-e5e5e5 margin-left-default"
            />
          </section>
        </form>
      </section>
    </section>
  );
};

export const ProviderDetails = (props) => {
  const [providerData, setProviderData] = useState({
    requestToAccess: props.requestToAccess,
    from: "",
    to: ""
  });
  const monthCalculator = (month) => {
    return new Date(
      new Date().getFullYear(),
      new Date().getMonth() + month,
      new Date().getDate()
    ).toISOString();
  };

  const [date, setDate] = useState({
    from: props.from,
    to: props.to,
    expire: props.expire
  });

  const [selectedCareContexts, setSelectedCareContexts] = useState([]);
  const [expireMonth, setExpireMonth] = useState(0);
  const [showCheckBox, setShowCheckBox] = useState(false);

  useEffect(() => {
    if (props.variant === "consent") {
      setSelectedCareContexts(props.selectedCareContexts || []);
    } else {
      setSelectedCareContexts(
        props.needAccessTo?.map((data) =>
          String(data?.careContexts?.[0]?.referenceNumber)
        ) || []
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedCareContexts, props.needAccessTo]);

  // set expire month
  useEffect(() => {
    if (props.to === monthCalculator(3)) {
      setExpireMonth(3);
    } else if (props.to === monthCalculator(6)) {
      setExpireMonth(6);
    } else if (props.to === monthCalculator(12)) {
      setExpireMonth(12);
    } else {
      setExpireMonth("Custom");
    }

    // eslint-disable-next-line
  }, []);

  // set showCheckbox
  useEffect(() => {
    if (isValidArray(props.healthLockersData)) {
      setShowCheckBox(
        props.healthLockersData.some(
          (data) =>
            data.hip.id === props.requesterId &&
            props.requesterId === lockerSetup.locker &&
            data.hip.type === "HEALTH_LOCKER"
        )
      );
    }

    // eslint-disable-next-line
  }, []);

  return (
    <section className="padding-larger">
      <div className="display-flex flex-grow-1 flex-align-items-center padding-bottom-large">
        <RoundedProfilePicture size="medium" />
        <div className="padding-left-medium font-size-medium font-family-gilroy-regular font-color-secondary">
          {props.consentRequesterName}
        </div>
      </div>
      <HiTypes
        status={props.status}
        edit={props.edit}
        hiTypes={props.requestToAccess}
        consentIds={props.givenAccessTo}
        providerData={providerData?.requestToAccess}
        setProviderData={(hiTypes) => {
          setProviderData({ ...providerData, requestToAccess: hiTypes });
        }}
      />
      <ConditionalRender
        condition={
          (props.status === consentStatus.pending || props.edit) &&
          props.variant !== "consent"
        }
      >
        <div className="padding-top-large font-size-small font-color-secondary">
          ACCESS EXPIRES IN
        </div>
        <div
          className={`padding-top-small display-flex ${
            expireMonth === "Custom" ? "" : "padding-bottom-larger"
          }`}
        >
          {[3, 6, 12, "Custom"].map((month, index) => (
            <MonthsCard
              key={index}
              months={month}
              selected={expireMonth === month}
              monthsCardOnClick={() => {
                if (expireMonth === month) {
                  setExpireMonth(0);
                } else {
                  setExpireMonth(month);
                }
              }}
            />
          ))}
        </div>
      </ConditionalRender>
      <ConditionalRender
        condition={
          (props.status === consentStatus.pending &&
            props.variant === "consent") ||
          expireMonth === "Custom"
        }
      >
        <div className="display-flex margin-top-large padding-vertical-default">
          <InputBox
            className={
              "inherit-parent-width border-radius-default padding-right-medium"
            }
            label="FROM DATE"
            size="small"
            disabled={
              props.variant === "consent" &&
              props.status === consentStatus.approved
            }
            value={getLocalDate(date.from)}
            type="date"
            onChange={(event) => {
              const value = event.target.value;
              const parsed = value ? new Date(value) : null;

              setDate({
                ...date,
                from: parsed && !isNaN(parsed) ? parsed.toISOString() : ""
              });
            }}
          />
          <InputBox
            className="inherit-parent-width border-radius-default  padding-left-medium"
            label="TO DATE"
            size="small"
            disabled={
              props.variant === "consent" &&
              props.status === consentStatus.approved
            }
            value={getLocalDate(date.to)}
            type="date"
            maxDate={(() => {
              const to = new Date(date?.to);

              if (isNaN(to)) {
                return "";
              }

              return new Date(to.getFullYear(), to.getMonth() + 6, to.getDate())
                .toISOString()
                .split("T")[0];
            })()}
            onChange={(event) => {
              const value = event.target.value;
              const parsed = value ? new Date(value) : null;

              setDate({
                ...date,
                to: parsed && !isNaN(parsed) ? parsed.toISOString() : ""
              });
            }}
          />
        </div>
        {props.variant !== "consent" && expireMonth === "Custom" && (
          <div className="display-flex  padding-vertical-default">
            <InputBox
              className="inherit-parent-width border-radius-default "
              label="FROM TIME"
              size="small"
              disabled={
                props.variant === "consent" &&
                props.status === consentStatus.approved
              }
              type="time"
              value={getLocalTime(date.from)}
              onChange={(event) => {
                const updatedISO = mergeLocalDateAndTime(
                  date.from,
                  null,
                  event.target.value
                );

                setDate({
                  ...date,
                  from: updatedISO
                });
              }}
            />
            <InputBox
              className="inherit-parent-width border-radius-default padding-left-medium"
              label="TO TIME"
              size="small"
              disabled={
                props.variant === "consent" &&
                props.status === consentStatus.approved
              }
              type="time"
              value={getLocalTime(date.to)}
              onChange={(event) => {
                const updatedISO = mergeLocalDateAndTime(
                  date.to,
                  null,
                  event.target.value
                );

                setDate({
                  ...date,
                  to: updatedISO
                });
              }}
            />
          </div>
        )}
        {props.variant === "consent" && (
          <div className="display-flex">
            <InputBox
              className="inherit-parent-width border-radius-default padding-right-medium"
              label="EXPIRE AT DATE"
              size="small"
              disabled={props.status === consentStatus.approved}
              type="date"
              value={getLocalDate(date.expire)}
              maxDate={(() => {
                const to = new Date(date?.to);
                if (isNaN(to)) return "";

                return new Date(
                  to.getFullYear(),
                  to.getMonth() + 6,
                  to.getDate()
                )
                  .toISOString()
                  .split("T")[0];
              })()}
              onChange={(event) => {
                const updatedISO = mergeLocalDateAndTime(
                  date.expire,
                  event.target.value,
                  null
                );

                setDate({
                  ...date,
                  expire: updatedISO
                });
              }}
            />

            <InputBox
              className="inherit-parent-width border-radius-default padding-left-medium"
              label="EXPIRE AT TIME"
              size="small"
              disabled={props.status === consentStatus.approved}
              type="time"
              value={getLocalTime(date.expire)}
              onChange={(event) => {
                const updatedISO = mergeLocalDateAndTime(
                  date.expire,
                  null,
                  event.target.value
                );

                setDate({
                  ...date,
                  expire: updatedISO
                });
              }}
            />
          </div>
        )}
      </ConditionalRender>
      <ConditionalRender condition={showCheckBox}>
        <div className="display-flex flex-align-items-center margin-bottom-large">
          <div className="display-flex">
            <CheckBox
              name="allowClones"
              id="allowClones"
              checked={props.dataClone}
              onChange={(event) => {
                props.onChangeCheckBox(event.target.checked);
              }}
              data-cy={"allowClones-checkBox"}
            />
          </div>

          {/* <div
              className="inherit-parent-width flex-justify-content-space-between"
              onClick={() => {}}
            > */}
          <div className="font-color-secondary font-family-gilroy-regular font-size-medium">
            Allow access to synced records
          </div>

          {/* </div> */}
        </div>
      </ConditionalRender>

      {props.consentRequesterName !== "All providers" && (
        <div className="inherit-parent-height">
          <div className="font-color-secondary font-family-gilroy-medium font-size-small letter-spacing-4-percentage padding-bottom-default">
            HEALTH DATA FROM SELECTED CARE CONTEXTS WILL BE SHARED
          </div>
          <div
            style={{
              height: "200px",

              maxHeight: "calc(100% - 200px)"
            }}
            className="overflow-scroll hide-scroll-bar"
          >
            {isValidArray(props.needAccessTo) ? (
              props.needAccessTo?.map((data) => {
                const refNo = String(
                  data?.careContexts?.[0]?.referenceNumber ?? ""
                );

                return (
                  <DocumentCard
                    checkBoxName={refNo}
                    checkBoxOnChange={() => {
                      if (!refNo) return;
                      setSelectedCareContexts((prev) =>
                        prev?.includes(refNo)
                          ? prev.filter((d) => d !== refNo)
                          : [...prev, refNo]
                      );
                    }}
                    checkBoxChecked={
                      refNo ? selectedCareContexts?.includes(refNo) : false
                    }
                    data={{
                      display: data?.careContexts?.[0]?.display,
                      referenceNumber: refNo
                    }}
                  />
                );
              })
            ) : (
              <div>No Records Found</div>
            )}
          </div>
        </div>
      )}
      {/* <ConditionalRender
        condition={props.status === consentStatus.approved && !props.edit}
      >
        <div className=" font-size-smaller font-color-secondary">
          ACCESS EXPIRES ON
        </div>
        <div className="margin-bottom-larger padding-top-small font-size-medium font-color-secondary">
          {`${new Date(props.to).getDate()}/${new Date(
            props.to
          ).getMonth()}/${new Date(props.to).getFullYear()}`}
          {""}
          {remainingDateConversion(props.to)}
        </div>
      </ConditionalRender> */}
      <ConditionalRender
        condition={props.status === consentStatus.pending || props.edit}
      >
        <Button
          className="font-family-gilroy-medium margin-top-large"
          data-cy="CONTINUE-BUTTON"
          boxShadow={false}
          text="Continue"
          disabled={props.variant !== "consent" && expireMonth === 0}
          onClick={() => {
            if (props.variant === "consent") {
              props.continueOnClick({
                requestToAccess: providerData.requestToAccess,
                from: date.from,
                to: date.to,
                expire: date.expire,
                selectedCareContexts
              });
            } else if (expireMonth === "Custom") {
              props.continueOnClick({
                ...providerData,
                from: date.from,
                to: date.to
              });
            } else {
              props.continueOnClick({
                ...providerData,
                from: new Date().toISOString(),
                to: new Date(
                  new Date().getFullYear(),
                  new Date().getMonth() + expireMonth,
                  new Date().getDate()
                ).toISOString()
              });
            }
          }}
        />
      </ConditionalRender>
      <ConditionalRender
        condition={props.status !== consentStatus.pending && !props.edit}
      >
        <Button
          text="Back"
          boxShadow={false}
          className="font-family-gilroy-medium margin-top-large display-block"
          onClick={() => {
            props.backOnClick();
          }}
        />
      </ConditionalRender>
    </section>
  );
};

const Chip = (props) => {
  return (
    <div
      data-cy={`${props.text}-chip`.toUpperCase()}
      className="background-color-grey font-family-gilroy-regular font width-fit-content border-radius-default font-size-smaller padding-left-medium padding-right-medium height-fit-to-content padding-top-small padding-bottom-small text-transform-uppercase letter-spacing-4-percentage margin-right-default margin-bottom-default"
    >
      {props.text}
    </div>
  );
};

const HiTypes = (props) => {
  const chips = props.providerData;
  return props.status === consentStatus.pending || props.edit ? (
    <Select
      onChipAdded={(chip) => {
        props.setProviderData(chip);
      }}
      modalTitle="Choose your Health info type"
      multiSelect={true}
      showSelectAll
      name="healthInfo"
      label="Request to access"
      labelClassName="letter-spacing-4-percentage padding-bottom-default"
      data-cy="health-info-select-box-comp"
      showAddOption={false}
      options={AbdmConsentHealthInfoTypes}
      chips={chips}
    />
  ) : (
    <>
      <div className="font-color-secondary font-family-gilroy-regular font-size-smaller text-transform-uppercase letter-spacing-4-percentage padding-bottom-small">
        Requested to access
      </div>
      <div className="display-flex flex-wrap-wrap padding-bottom-larger padding-top-default">
        {props.providerData?.map((type, index) => (
          <React.Fragment key={`${type}${index}`}>
            <Chip text={type} />
          </React.Fragment>
        ))}
      </div>
      {isValidArray(props.consentIds) && (
        <>
          <div className="font-color-secondary font-family-gilroy-regular font-size-smaller text-transform-uppercase letter-spacing-4-percentage padding-bottom-small">
            Given access to
          </div>
          <div className="display-flex flex-direction-column padding-top-default">
            {props.consentIds?.map((type, index) => (
              <div
                className="display-flex flex-align-items-center"
                key={`${type}${index}`}
              >
                <div className="padding-right-default padding-bottom-medium">
                  <CheckBox name={`${type}${index}`} checked={true} />
                </div>
                <Chip text={type} />
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export const AbdmRequestApproveSection = (props) => {
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        props.approveOnClick();
      }}
    >
      <section className="padding-larger">
        <div className="font-size-medium padding-bottom-larger text-align-center font-family-gilroy-medium font-color-secondary">
          Do you want to approve this request?
        </div>

        <section className="display-flex padding-top-larger">
          <Button
            loading={props.loading}
            boxShadow={false}
            type="submit"
            text="Approve"
            data-cy="approve-confirm-button"
            className="border-1px-e5e5e5 margin-right-small font-family-gilroy-medium"
          />
          <Button
            boxShadow={false}
            text="Cancel"
            variant="secondary"
            onClick={props.cancelOnClick}
            className="font-color-secondary border-1px-e5e5e5 margin-left-small"
          />
        </section>
      </section>
    </form>
  );
};

export const AbdmRequestDenyReasonInputSection = (props) => {
  const [reason, setReason] = useState("");
  // reason is optional, but when provided it must match the allowed format
  const isReasonValid =
    !reason || validation("requestDenyReason", reason).status === true;

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        if (!isReasonValid) {
          return;
        }
        props.denyOnClick();
      }}
    >
      <section className="padding-larger">
        <div className="font-size-medium  text-align-center font-family-gilroy-medium font-color-secondary">
          Why you are denying this request?
        </div>
        <InputBox
          className="margin-vertical-large"
          type="text"
          value={reason}
          name="requestDenyReason"
          onChange={(event) => {
            if (typeof props.reasonInputOnChange === "function") {
              props.reasonInputOnChange(event);
            }
            setReason(event.target.value);
          }}
          validation={(value) =>
            value ? validation("requestDenyReason", value) : { status: true }
          }
          label="Specify reason"
          labelClassName="letter-spacing-4-percentage"
        />
        <section className="display-flex padding-top-default">
          <Button
            loading={props.loading}
            boxShadow={false}
            type="submit"
            variant={"danger"}
            text="Deny"
            data-cy={`deny-confirm-button`}
            disabled={!isReasonValid}
            className={
              "border-1px-e5e5e5 margin-right-small font-family-gilroy-medium"
            }
          />
          <Button
            boxShadow={false}
            text="Cancel"
            variant="secondary"
            onClick={props.cancelOnClick}
            className={
              "font-color-secondary border-1px-e5e5e5 margin-left-small"
            }
          />
        </section>
      </section>
    </form>
  );
};

export const RevokeAccessSection = (props) => {
  return (
    <section className="font-color-secondary font-family-gilroy-medium font-color-secondary text-align-center padding-large">
      <section className="">
        <div className="font-size-medium ">Revoke access to these records?</div>
        <div className="font-size-small padding-top-large">
          By revoking access to this service, They won’t be able to access the
          mentioned records. Are you sure?
        </div>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            props.revokeOnClick();
          }}
        >
          <section className="display-flex padding-top-larger">
            <Button
              loading={props.loading}
              boxShadow={false}
              type="submit"
              variant={"danger"}
              text="Revoke access"
              className={"border-1px-e5e5e5 margin-right-small"}
              data-cy={"revoke-access-button"}
            />
            <Button
              boxShadow={false}
              text="Cancel"
              variant={"secondary"}
              onClick={() => {
                if (typeof props.cancelOnClick === "function") {
                  props.cancelOnClick();
                }
              }}
              className={
                "font-color-secondary border-1px-e5e5e5 margin-left-small"
              }
              data-cy={"cancel-revoke-button"}
            />
          </section>
        </form>
      </section>
    </section>
  );
};

export const EnableAutoApproveSection = (props) => {
  return (
    <section className="font-color-secondary font-family-gilroy-medium font-color-secondary text-align-center padding-larger">
      <section className="">
        <div className="">Enable auto-approval</div>
        <div className="font-size-small padding-top-large">
          Enabling this auto-approval policy would initiate consent requests
          from{" "}
          <span className="font-family-gilroy-bold">{props.hospitalName}</span>{" "}
          to be automatically approved.
        </div>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            props.enableOnclick();
          }}
        >
          <section className="display-flex padding-top-larger">
            <Button
              loading={props.loading}
              boxShadow={false}
              type="submit"
              variant={"primary"}
              text="Enable"
              className={"border-1px-e5e5e5 margin-right-small"}
            />
            <Button
              boxShadow={false}
              text="Cancel"
              variant={"secondary"}
              onClick={() => {
                props.cancelOnClick();
              }}
              className={
                "font-color-secondary border-1px-e5e5e5 margin-left-small"
              }
            />
          </section>
        </form>
      </section>
    </section>
  );
};

export const RequestSuspense = () => {
  return (
    <section
      className="remaining-body-height padding-left-large padding-right-large overflow-y-auto padding-top-medium"
      data-cy="view-filled-form"
    >
      {[...Array(10)].map((_val, index) => (
        <span
          key={index}
          className="padding-left-large padding-right-large margin-vertical-larger"
        >
          <div className="shimmer width-30-percentage padding-small margin-vertical-default border-radius-default" />
          <div className="shimmer width-90-percent padding-default border-radius-default margin-bottom-large" />
        </span>
      ))}
    </section>
  );
};

const getLocalDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(d.getDate()).padStart(2, "0")}`;
};

const getLocalTime = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2, "0")}:${String(
    d.getMinutes()
  ).padStart(2, "0")}`;
};

const mergeLocalDateAndTime = (dateISO, dateStr, timeStr) => {
  const base =
    dateISO && !isNaN(new Date(dateISO)) ? new Date(dateISO) : new Date();

  if (dateStr) {
    const [y, m, d] = dateStr.split("-").map(Number);
    base.setFullYear(y, m - 1, d);
  }

  if (timeStr) {
    const [h, min] = timeStr.split(":").map(Number);
    base.setHours(h, min, 0, 0);
  }

  return base.toISOString();
};

const MonthsCard = (props) => {
  return (
    <div
      className={`${
        props.selected ? "border-primaryColor" : "border-tertiaryColor"
      } font-family-gilroy-regular font-size-small border-radius-default width-fit-content padding-small display-flex flex-align-items-center margin-right-medium`}
      onClick={() => {
        props.monthsCardOnClick();
      }}
    >
      {props.selected && <TickIcon color={"#00A000"} width={12} />}

      <div
        className={props.selected && "padding-left-small font-color-primary"}
      >
        {props.months} {props.months === "Custom" ? "" : "months"}
      </div>
    </div>
  );
};
